import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchLoveRequests, acceptLoveRequest, declineLoveRequest } from '../../store/slices/loveRequestsSlice';
import { fetchLoves, removeLove } from '../../store/slices/lovesSlice';
import PageHeader from '../../components/common/PageHeader';
import { FaHeart, FaCheck, FaTimes, FaSpinner, FaUser, FaEnvelope, FaComment, FaTrash, FaCalendarAlt } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext';
import './Loves.css';



const Loves = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sent, received, loading: requestsLoading, error: requestsError } = useSelector((state) => state.loveRequests);
  const { items: loves, loading: lovesLoading, error: lovesError } = useSelector((state) => state.loves);
  const { isDark } = useTheme();
  const [activeTab, setActiveTab] = useState('received');

  useEffect(() => {
    dispatch(fetchLoveRequests());
    dispatch(fetchLoves());
  }, [dispatch]);


  const handleAccept = async (requestId) => {
    await dispatch(acceptLoveRequest(requestId));
  };

  const handleDecline = async (requestId) => {
    await dispatch(declineLoveRequest(requestId));
  };

  const handleRemoveLove = async (loveId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce match ?')) {
      await dispatch(removeLove(loveId));
    }
  };

  const handleMessage = (userId) => {
    navigate('/messages');
  };

  const handleViewProfile = (userId) => {
    navigate(`/profile/${userId}`);
  };


  const LoveRequestCard = ({ request, type }) => {
    const user = type === 'sent' ? request.receiver : request.sender;

    return (
      <div className="love-request-card">
        <div className="user-info">
          <img
            src={user?.profile?.photo_url || user?.photo_url || '/default-avatar.svg'}

            alt={user?.username}
            className="user-avatar"
          />
          <div className="user-details">
            <h4>{user?.first_name} {user?.last_name}</h4>
            <p className="username">@{user?.username}</p>
            {request.message && (
              <p className="message">
                <FaEnvelope /> {request.message}
              </p>
            )}
            <span className="request-date">
              {new Date(request.created_at).toLocaleDateString('fr-FR')}
            </span>
          </div>
        </div>

        <div className="request-status">
          {type === 'received' && request.status === 'pending' && (
            <div className="action-buttons">
              <button
                className="accept-btn"
                onClick={() => handleAccept(request.id)}
              >
                <FaCheck /> Accepter
              </button>
              <button
                className="decline-btn"
                onClick={() => handleDecline(request.id)}
              >
                <FaTimes /> Refuser
              </button>
            </div>
          )}

          {request.status === 'accepted' && (
            <div className="status accepted">
              <FaHeart color="#e74c3c" /> Match !
            </div>
          )}

          {request.status === 'declined' && (
            <div className="status declined">
              <FaTimes color="#95a5a6" /> Refusé
            </div>
          )}

          {request.is_super_like && (
            <div className="super-like-badge">
              <FaHeart color="#ffd700" /> Super Like
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="loves-page">
      <PageHeader
        title="❤️ Mes Loves"
        subtitle="Gérez vos demandes d'amour et vos matches"
      />

      <div className="loves-tabs">
        <button
          className={activeTab === 'received' ? 'active' : ''}
          onClick={() => setActiveTab('received')}
        >
          Reçues ({received.filter(r => r.status === 'pending').length})
        </button>
        <button
          className={activeTab === 'sent' ? 'active' : ''}
          onClick={() => setActiveTab('sent')}
        >
          Envoyées ({sent.filter(r => r.status === 'pending').length})
        </button>

        <button
          className={activeTab === 'matches' ? 'active' : ''}
          onClick={() => setActiveTab('matches')}
        >
          Matches ({[...sent, ...received].filter(r => r.status === 'accepted').length})
        </button>
        <button
          className={activeTab === 'loves' ? 'active' : ''}
          onClick={() => setActiveTab('loves')}
        >
          Mes Loves ({loves.length})
        </button>
      </div>


      <div className="loves-content">
        {requestsLoading || lovesLoading ? (
          <div className="loading-container">
            <FaSpinner className="spinner" />
            <p>Chargement...</p>
          </div>
        ) : requestsError || lovesError ? (
          <div className="error-container">
            <p>Erreur: {requestsError || lovesError}</p>
          </div>
        ) : (

          <>
            {activeTab === 'received' && (
              <div className="requests-section">
                <h2>Demandes reçues</h2>
                {received.filter(r => r.status === 'pending').length > 0 ? (
                  <div className="requests-list">
                    {received.filter(r => r.status === 'pending').map((request) => (
                      <LoveRequestCard key={request.id} request={request} type="received" />
                    ))}
                  </div>

                ) : (
                  <div className="empty-section">
                    <FaHeart size={48} color="#ccc" />
                    <h3>Aucune demande reçue</h3>
                    <p>Les demandes d'amour apparaîtront ici</p>
                  </div>
                )}
              </div>
            )}

            {activeTab === 'sent' && (
              <div className="requests-section">
                <h2>Demandes envoyées</h2>
                {sent.filter(r => r.status === 'pending').length > 0 ? (
                  <div className="requests-list">
                    {sent.filter(r => r.status === 'pending').map((request) => (
                      <LoveRequestCard key={request.id} request={request} type="sent" />
                    ))}
                  </div>

                ) : (
                  <div className="empty-section">
                    <FaUser size={48} color="#ccc" />
                    <h3>Aucune demande envoyée</h3>
                    <p>Envoyez des demandes d'amour pour commencer !</p>
                  </div>
                )}
              </div>
            )}

            {activeTab === 'matches' && (
              <div className="requests-section">
                <h2>Mes Matches</h2>
                {[...sent, ...received].filter(r => r.status === 'accepted').length > 0 ? (
                  <div className="requests-list">
                    {[...sent, ...received]
                      .filter(r => r.status === 'accepted')
                      .map((request) => (
                        <LoveRequestCard
                          key={request.id}
                          request={request}
                          type={sent.includes(request) ? 'sent' : 'received'}
                        />
                      ))}
                  </div>
                ) : (
                  <div className="empty-section">
                    <FaHeart size={48} color="#e74c3c" />
                    <h3>Aucun match</h3>
                    <p>Continuez à liker pour trouver l'amour !</p>
                  </div>
                )}
              </div>
            )}

            {activeTab === 'loves' && (
              <div className="requests-section">
                <h2>Mes Loves</h2>
                {loves.length > 0 ? (
                  <div className="loves-list">
                    {loves.map((love) => (
                      <div key={love.id} className="love-card">
                        <div className="user-info">
                          <img
                            src={love.other_user?.photo_url || '/default-avatar.svg'}
                            alt={love.other_user?.username}
                            className="user-avatar"
                          />
                          <div className="user-details">
                            <h4>{love.other_user?.first_name} {love.other_user?.last_name}</h4>
                            <p className="username">@{love.other_user?.username}</p>
                            <span className="match-date">
                              <FaCalendarAlt /> Match depuis le {new Date(love.matched_at).toLocaleDateString('fr-FR')}
                            </span>
                          </div>
                        </div>

                        <div className="love-actions">
                          <button
                            className="message-btn"
                            onClick={() => handleMessage(love.other_user?.id)}
                            title="Envoyer un message"
                          >
                            <FaComment /> Message
                          </button>
                          <button
                            className="view-profile-btn"
                            onClick={() => handleViewProfile(love.other_user?.id)}
                            title="Voir le profil"
                          >
                            <FaUser /> Profil
                          </button>
                          <button
                            className="remove-love-btn"
                            onClick={() => handleRemoveLove(love.id)}
                            title="Supprimer le match"
                          >
                            <FaTrash /> Retirer
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-section">
                    <FaHeart size={48} color="#e74c3c" />
                    <h3>Aucun love</h3>
                    <p>Vous n'avez pas encore de match. Continuez à liker pour trouver l'amour !</p>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};


export default Loves;
